import { StrictMode, useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./lib/i18n/config";
import i18n from "./lib/i18n/config";

import { RouterProvider } from "./lib/router";
import { routes } from "./router";
import { ensureAuthIdentity } from "./lib/auth";
import { identify } from "./lib/analytics";
import { useAppStore } from "./lib/store";

Sentry.init({
  dsn: "https://b69603218cfb403ea7a1e9c6dcf9c01f@errors.wikiparty.org/1",
  tracesSampleRate: 0.1,
  enabled: !import.meta.env.DEV,
});

function AuthGate() {
  const [error, setError] = useState(false);
  const [ready, setReady] = useState(false);

  const initialize = useCallback(() => {
    setError(false);
    void ensureAuthIdentity()
      .then((identity) => {
        useAppStore.getState().setAuthIdentity(identity);
        identify({ id: identity.id });
        setReady(true);
      })
      .catch(() => setError(true));
  }, []);

  useEffect(initialize, [initialize]);

  if (error) {
    return (
      <main className="min-h-screen bg-black text-white flex items-center justify-center p-6">
        <div className="text-center">
          <p>{i18n.t("errors.authFailed")}</p>
          <button
            data-testid="retry-auth-btn"
            className="mt-4 cursor-pointer rounded-xl border-[3px] border-ink bg-gold px-5 py-2 font-display text-ink shadow-board-sm press"
            onClick={initialize}
          >
            {i18n.t("account.retry")}
          </button>
        </div>
      </main>
    );
  }
  if (!ready) return null;
  return <RouterProvider routes={routes} />;
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <AuthGate />
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );
}
